<template>
<div>
    <h1>Agenda</h1>
    <DialogView v-model:visible="blocker" style="width:60%; text-align:center" :keepInViewport="false">
    <h2>Voulez-vous supprimer le blocker?</h2>
      <template #footer>
              <InputButton @click="deleteBlocker">Oui</InputButton>
              <InputButton @click="blocker=false">Non</InputButton>
            </template>
    </DialogView>

    <DialogView v-model:visible="display" class="appointmentDialog" :style="appointmentDialogStyle" :keepInViewport="false">
    <template #header>
		<div class="appointmentHeader">
      <h2>{{ dialogTitle }}</h2>
      <div class="appointmentHeaderMeta">
        <span class="metaTag">{{ appointmentDateLabel }}</span>
        <span class="metaTag">{{ durationLabel }}</span>
      </div>
    </div>
	</template>

<div class="appointmentContent">
  <div class="timeSection">
    <div class="field">
      <label for="timebegin">Début</label>
      <CalendarView :timeOnly="false" id="timebegin" v-model="startTime" :showTime="true" :stepMinute="15"/>
    </div>
    <div class="field">
      <label for="timeend">Fin</label>
      <CalendarView :timeOnly="false" id="timeend" v-model="endTime" :showTime="true" :stepMinute="15" />
    </div>
  </div>
  <small v-show="timeerror && submitted" class="p-error">Merci de vérifier les horaires</small>

  <div class="typeSection" v-if="!contextualClient">
    <button type="button" class="typeCard" :class="{ active: apptype === 'appointment' }" @click="apptype = 'appointment'">
      <span class="typeTitle">Rendez-vous</span>
      <small>Créer un RDV client</small>
    </button>
    <button type="button" class="typeCard" :class="{ active: apptype === 'blocker' }" @click="apptype = 'blocker'">
      <span class="typeTitle">Blocker</span>
      <small>Bloquer un créneau</small>
    </button>
    <button type="button" class="typeCard" :class="{ active: apptype === 'availability' }" @click="apptype = 'availability'">
      <span class="typeTitle">Ouverture</span>
      <small>Ouverture ponctuelle</small>
    </button>
  </div>

  <div class="p-fluid clientdata" v-show="apptype=='appointment'">
    <div class="field" v-if="!contextualClient">
      <label for="existingClient">Client existant (recherche rapide)</label>
      <AutoComplete
        id="existingClient"
        v-model="selectedExistingClient"
        :suggestions="filteredClients"
        @item-select="onExistingClientSelect($event)"
        @complete="searchClient($event)"
        field="displayLabel"
        forceSelection
        autoHighlight
        inputStyle="width: 100%"
      />
      <small v-if="selectedExistingClient && selectedExistingClient.clientid">
        RDV assigné à: {{ selectedExistingClient.name }}
      </small>
    </div>

    <div class="clientGrid" v-if="!contextualClient">
      <div class="field">
        <label for="firstname">Prénom</label>
        <InputText id="firstname" v-model="firstname" :readonly="!!(selectedExistingClient && selectedExistingClient.clientid)" @keyup.enter="nextPage()" :class="{'p-invalid': validationErrors.firstname && submitted}" />
        <small v-show="validationErrors.firstname && submitted" class="p-error">Merci d'indiquer votre prénom</small>
      </div>
      <div class="field">
        <label for="lastname">Nom</label>
        <InputText id="lastname" v-model="lastname" :readonly="!!(selectedExistingClient && selectedExistingClient.clientid)" @keyup.enter="nextPage()" :class="{'p-invalid': validationErrors.lastname && submitted}" />
        <small v-show="validationErrors.lastname && submitted" class="p-error">Merci d'indiquer votre nom de famille.</small>
      </div>
    </div>

    <div class="field" v-if="!contextualClient">
      <label for="phone">Numéro de téléphone</label>
      <InputText id="phone" v-model="phone" :readonly="!!(selectedExistingClient && selectedExistingClient.clientid)" @keyup.enter="nextPage()" />
      <small v-show="validationErrors.phone && submitted" class="p-error">Veuillez entrer un numéro de téléphone valide</small>
    </div>

    <div class="field" v-if="!appointmentEdit">
      <label for="services">Services</label>
      <InputText id="services" v-model="services" @keyup.enter="nextPage()" :class="{'p-invalid': validationErrors.services && submitted}" placeholder="Ex: Coupe + Brushing"/>
      <small v-show="validationErrors.services && submitted" class="p-error">Merci d'indiquer au moins un service</small>
    </div>
  </div>

  <div class="p-fluid blockerdata" v-show="apptype=='blocker'">
    <div class="field">
      <label for="blockerreason">Raison (optionnel)</label>
      <InputText id="blockerreason" v-model="blockerreason" @keyup.enter="nextPage()" :class="{'p-invalid': validationErrors.blockerreason && submitted}" placeholder="Ex: Pause, congé, réunion..." />
    </div>
  </div>

  <div class="p-fluid blockerdata" v-show="apptype=='availability'">
    <div class="infoBox">
      Ajoute une ouverture exceptionnelle sur ce créneau (non récurrente).
    </div>
  </div>
</div>

            <template #footer>
              <InputButton :label="submitLabel" icon="pi pi-check" class="dialogSubmitBtn" @click="bookAppointment"/>
              <InputButton label="Annuler" icon="pi pi-times" class="p-button-text dialogCancelBtn" @click="display=false"/>
            </template>

</DialogView>

    <MessageItem v-if="editedEvent" severity="info" :closable="false">Vous êtes en train de déplacer le RDV de <b>{{editedEvent.title}}</b> actuellement prévu de {{editedEvent.date}} à {{editedEvent.end}}</MessageItem>
    <GridLoader v-if="loading" class="loader"></GridLoader>
    <div class="agendaCalendarShell" :class="{ mobileCalendarShell: isMobileViewport }">
      <FullCalendar ref="fullcalendar" :events="events" :options="options" :disabled="loading"/>
    </div>


   
</div>
</template>

<style scoped>
  label {
    margin-right:2px;
  }

.agendaCalendarShell {
  border: 1px solid #dfe6f3;
  border-radius: 14px;
  background: #ffffff;
  box-shadow: 0 8px 20px rgba(13, 31, 84, 0.05);
  overflow: hidden;
}

.agendaCalendarShell :deep(.fc .fc-toolbar.fc-header-toolbar) {
  margin-bottom: 0;
  padding: 0.8rem 0.9rem;
  border-bottom: 1px solid #e6edf8;
}

.agendaCalendarShell :deep(.fc .fc-toolbar-title) {
  color: #182b52;
  font-size: 1.75rem;
  line-height: 1.1;
  text-transform: lowercase;
}

.agendaCalendarShell :deep(.fc .fc-button) {
  border-radius: 9px;
  font-weight: 600;
}

.agendaCalendarShell :deep(.fc .fc-timegrid-event) {
  border-radius: 6px;
}

.appointmentHeader {
  text-align: left;
}

.appointmentHeader h2 {
  margin: 0 0 8px 0;
}

.appointmentHeaderMeta {
  display: flex;
  gap: 8px;
  flex-wrap: wrap;
}

.metaTag {
  background: #eef3fb;
  border: 1px solid #dbe5f5;
  color: #2f4467;
  border-radius: 999px;
  padding: 4px 10px;
  font-size: 0.8rem;
}

.appointmentContent {
  text-align: left;
  display: grid;
  gap: 12px;
}

.timeSection {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 10px;
}

.typeSection {
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: 8px;
}

.typeCard {
  border: 1px solid #d7e1f0;
  background: #ffffff;
  border-radius: 10px;
  padding: 10px;
  text-align: left;
  cursor: pointer;
}

.typeCard.active {
  border-color: #91aedf;
  background: #f3f8ff;
}

.typeTitle {
  display: block;
  font-weight: 700;
  margin-bottom: 3px;
}

.clientGrid {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 10px;
}

.infoBox {
  border: 1px solid #d9e5f7;
  background: #f7fbff;
  border-radius: 10px;
  padding: 10px;
  color: #3c5479;
}

.loader {
    z-index:1000;
    position: absolute;
    left:50%;
    top:50%;
  }

@media (max-width: 900px) {
  .timeSection,
  .typeSection,
  .clientGrid {
    grid-template-columns: 1fr;
  }
}

@media (max-width: 991px) {
  .mobileCalendarShell {
    border-radius: 12px;
    overflow-x: auto;
    overflow-y: hidden;
    overscroll-behavior: contain;
    -webkit-overflow-scrolling: touch;
  }

  .agendaCalendarShell :deep(.fc .fc-toolbar.fc-header-toolbar) {
    align-items: center;
    flex-wrap: wrap;
    gap: 8px;
  }

  .agendaCalendarShell :deep(.fc .fc-toolbar-title) {
    font-size: 1.02rem;
  }

  .agendaCalendarShell :deep(.fc .fc-toolbar-chunk) {
    display: flex;
    width: auto;
    justify-content: flex-start;
    align-items: center;
    flex-wrap: wrap;
    gap: 8px;
  }

  .agendaCalendarShell :deep(.fc .fc-button) {
    padding: 0.45rem 0.62rem;
    font-size: 0.82rem;
  }

  .agendaCalendarShell :deep(.fc .fc-timegrid-axis-frame) {
    font-size: 0.78rem;
  }

  .agendaCalendarShell :deep(.fc .fc-timegrid-slot-label-cushion) {
    font-size: 0.75rem;
  }

  .agendaCalendarShell :deep(.fc .fc-col-header-cell-cushion) {
    font-size: 0.82rem;
    line-height: 1.2;
    padding: 6px 4px;
  }

  .agendaCalendarShell :deep(.fc .fc-timegrid-event) {
    font-size: 0.74rem;
  }

  .mobileCalendarShell :deep(.fc) {
    min-width: 690px;
  }

  .mobileCalendarShell :deep(.fc .fc-scroller),
  .mobileCalendarShell :deep(.fc .fc-scroller-harness) {
    -webkit-overflow-scrolling: touch;
    overscroll-behavior: contain;
  }

  .appointmentDialog :deep(.p-dialog) {
    width: 100vw !important;
    max-width: 100vw !important;
    margin: 0 !important;
    max-height: 100dvh;
    border-radius: 0 !important;
  }

  .appointmentDialog :deep(.p-dialog-content) {
    max-height: calc(100dvh - 190px);
    overflow-y: auto;
    -webkit-overflow-scrolling: touch;
    padding: 0.85rem max(0.85rem, env(safe-area-inset-right)) 0.85rem max(0.85rem, env(safe-area-inset-left));
  }

  .appointmentDialog :deep(.p-dialog-header) {
    padding: 0.8rem max(0.85rem, env(safe-area-inset-right)) 0.65rem max(0.85rem, env(safe-area-inset-left));
  }

  .appointmentDialog :deep(.p-dialog-footer) {
    padding: 0.65rem 0.85rem 0.85rem;
    gap: 8px;
    flex-direction: column !important;
    align-items: stretch !important;
    justify-content: stretch !important;
  }

  .appointmentDialog :deep(.dialogSubmitBtn),
  .appointmentDialog :deep(.dialogCancelBtn) {
    min-height: 36px;
    font-size: 0.92rem;
    padding: 0.4rem 0.55rem;
    flex: 0 0 auto;
    width: 100% !important;
    justify-content: center;
    white-space: normal;
    margin: 0 !important;
    display: inline-flex;
  }

  .appointmentDialog :deep(.dialogCancelBtn) {
    border: 1px solid #cfd8ea;
    background: #ffffff;
    color: #3d4f73;
  }

  .appointmentDialog :deep(.p-inputtext) {
    font-size: 1rem;
  }
}
</style>

<script setup>




import { ref, onBeforeMount, onMounted, onBeforeUnmount, nextTick, defineProps, defineEmits, computed, watch } from 'vue';
import timeGridPlugin from '@fullcalendar/timegrid';
import dayGridPlugin from '@fullcalendar/daygrid';
import interactionPlugin from '@fullcalendar/interaction';
import axios from 'axios';
import { useRouter } from 'vue-router';
import { getDate, getTime } from  '../dateUtils.js'
import GridLoader from './GridLoader.vue';
import { useMainStore } from '../store'
import { authHeader } from '../helpers/authHeader.js'
import { userService } from '../services/userService.js'


const props = defineProps(['contextualClient', 'appointmentEdit']);
const emit = defineEmits(['closeModal']);


const store = useMainStore();



const loadDate = ref(null);
const loadView = ref('timeGridWeek');
const isMobileViewport = ref(false);
const MOBILE_BREAKPOINT = 991;
let rafCalendarResizeId = null;

const fullcalendar = ref(null);

const loading = ref(false);

const currentView = ref("");

const startTime = ref(null);
const endTime = ref(null);

const minTime = ref(null);
const maxTime = ref(null);

const apptype = ref("appointment");

const router = useRouter();

const display = ref(false);

const services = ref("");

const firstname = ref("");
const lastname = ref("");
const phone = ref("");
const clients = ref([]);
const filteredClients = ref([]);
const selectedExistingClient = ref(null);


const timeerror = ref(false);

const blockerreason = ref("");

var submitted = ref(false);

const forceload = ref(false);

const blockerToDelete = ref(0);
const blocker = ref(false);



const events = ref([]);
const editedEventData = ref(null);
const editedEvent = computed(() => {
  return editedEventData.value;
});

const validationErrors = ref({});

const appointmentDateLabel = computed(() => {
  if (!startTime.value) {
    return "";
  }
  return startTime.value.toLocaleString('fr-CH', { weekday: "long", year: "numeric", month: "long", day: "numeric" });
});

const durationLabel = computed(() => {
  if (!startTime.value || !endTime.value) {
    return "Durée: -";
  }
  const diffMs = endTime.value.getTime() - startTime.value.getTime();
  const mins = Math.floor((diffMs / 1000) / 60);
  if (mins <= 0) {
    return "Durée: invalide";
  }
  return `Durée: ${mins} min`;
});

const dialogTitle = computed(() => {
  if (props.appointmentEdit != null) {
    return "Modifier le rendez-vous";
  }
  if (apptype.value === "blocker") {
    return "Nouveau blocker";
  }
  if (apptype.value === "availability") {
    return "Nouvelle ouverture";
  }
  return "Nouveau rendez-vous";
});

const submitLabel = computed(() => {
  if (props.appointmentEdit != null) {
    return "Enregistrer";
  }
  if (apptype.value === "blocker") {
    return "Créer blocker";
  }
  if (apptype.value === "availability") {
    return "Créer ouverture";
  }
  return "Créer rendez-vous";
});

const appointmentDialogStyle = computed(() => {
  if (isMobileViewport.value) {
    return {
      width: '100vw',
      maxWidth: '100vw',
      margin: '0'
    };
  }
  return {
    width: '68%',
    maxWidth: '900px'
  };
});


 onBeforeMount(() => {
    if(store.loadDate != '')
    {
      loadView.value = 'timeGridDay';
      loadDate.value = store.loadDate;
              store.$patch((state) => {
              state.loadDate = '';
  });

    }
    loadClients();
  });

onMounted(() => {
  applyResponsiveCalendarMode();
  window.addEventListener('resize', applyResponsiveCalendarMode, { passive: true });
  window.addEventListener('orientationchange', applyResponsiveCalendarMode, { passive: true });
  window.addEventListener('scroll', syncCalendarSize, { passive: true });
  if (window.visualViewport) {
    window.visualViewport.addEventListener('resize', syncCalendarSize, { passive: true });
    window.visualViewport.addEventListener('scroll', syncCalendarSize, { passive: true });
  }
  syncCalendarSize();
});

onBeforeUnmount(() => {
  window.removeEventListener('resize', applyResponsiveCalendarMode);
  window.removeEventListener('orientationchange', applyResponsiveCalendarMode);
  window.removeEventListener('scroll', syncCalendarSize);
  if (window.visualViewport) {
    window.visualViewport.removeEventListener('resize', syncCalendarSize);
    window.visualViewport.removeEventListener('scroll', syncCalendarSize);
  }
  if (rafCalendarResizeId != null) {
    cancelAnimationFrame(rafCalendarResizeId);
    rafCalendarResizeId = null;
  }
  document.body.classList.remove('mobile-dialog-open');
});

watch([display, blocker], ([dialogOpen, blockerOpen]) => {
  if (dialogOpen || blockerOpen) {
    document.body.classList.add('mobile-dialog-open');
    return;
  }
  document.body.classList.remove('mobile-dialog-open');
});

function syncCalendarSize() {
  if (rafCalendarResizeId != null) {
    cancelAnimationFrame(rafCalendarResizeId);
  }
  rafCalendarResizeId = requestAnimationFrame(async () => {
    await nextTick();
    const calendarApi = fullcalendar.value?.getApi ? fullcalendar.value.getApi() : fullcalendar.value?.calendar;
    if (calendarApi) {
      calendarApi.updateSize();
    }
  });
}

function isMobileScreen() {
  if (typeof window === "undefined") {
    return false;
  }
  return window.matchMedia(`(max-width: ${MOBILE_BREAKPOINT}px)`).matches;
}

function applyResponsiveCalendarMode() {
  const mobile = isMobileScreen();
  isMobileViewport.value = mobile;

  options.value.headerToolbar = mobile
    ? {
        left: 'prev,next today',
        center: 'title',
        right: 'timeGridMobileWeek,timeGridDay,dayGridMonth'
      }
    : {
        left: 'prev,next today',
        center: 'title',
        right: 'timeGridWeek,timeGridDay,dayGridMonth'
      };

  const calendarApi = fullcalendar.value?.getApi ? fullcalendar.value.getApi() : fullcalendar.value?.calendar;
  if (!calendarApi) {
    return;
  }

  if (mobile && calendarApi.view.type === 'timeGridWeek') {
    calendarApi.changeView('timeGridMobileWeek');
  } else if (!mobile && calendarApi.view.type === 'timeGridMobileWeek') {
    calendarApi.changeView('timeGridWeek');
  }
  syncCalendarSize();
}


function validateForm() {

console.log(props.contextualClient)

  const hasSelectedExistingClient = selectedExistingClient.value && selectedExistingClient.value.clientid;

  if(apptype.value == "appointment" && props.contextualClient == null && !hasSelectedExistingClient){
            if (!firstname.value.trim())
                validationErrors.value['firstname'] = true;
            else
                delete validationErrors.value['firstname'];

            if (!lastname.value.trim())
                validationErrors.value['lastname'] = true;
            else
                delete validationErrors.value['lastname'];

            if (!services.value.trim())
                validationErrors.value['services'] = true;
            else
                delete validationErrors.value['services'];

            var numbers = /^[0-9]+$/;
            if (!phone.value.trim() || !phone.value.trim().match(numbers) || phone.value.trim().length < 8)
                validationErrors.value['phone'] = true;
            else 
                delete validationErrors.value['phone'];

  } else {
            delete validationErrors.value['firstname'];
            delete validationErrors.value['lastname'];
            delete validationErrors.value['phone'];
  }

            return !Object.keys(validationErrors.value).length;
}

function loadClients()
{
      var options = {
        "headers" :  authHeader()
      };

      axios
      .get(`${process.env.VUE_APP_API_URL}/Clients`, options)
      .then(response => {
          clients.value = response.data.map(client => ({
            ...client,
            displayLabel: client.name
          }));
      }).catch(() => {
          clients.value = [];
      });
}

function searchClient(event)
{
        const query = event.query ? event.query.trim() : "";
        const queryName = normalizeText(query);
        const queryDigits = normalizePhone(query);
        const isPhoneSearch = queryDigits.length >= 3;

        if (!query.length) {
            filteredClients.value = clients.value.map(client => ({
              ...client,
              displayLabel: client.name
            }));
            return;
        }

        filteredClients.value = clients.value
          .filter((client) => {
            const nameMatch = normalizeText(client.name).includes(queryName);
            const phoneMatch = queryDigits.length > 0 && phoneMatches(client.phone, queryDigits);
            return nameMatch || phoneMatch;
          })
          .map(client => ({
            ...client,
            displayLabel: isPhoneSearch ? `${client.name} (${client.phone})` : client.name
          }));
}

function normalizeText(text) {
  return (text || "")
    .toLowerCase()
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, "");
}

function normalizePhone(text) {
  return (text || "").replace(/\D/g, "");
}

function phoneMatches(phone, queryDigits) {
  const phoneDigits = normalizePhone(phone);
  if (phoneDigits.includes(queryDigits)) {
    return true;
  }

  if (phoneDigits.startsWith("41")) {
    const localDigits = "0" + phoneDigits.substring(2);
    if (localDigits.includes(queryDigits)) {
      return true;
    }
  }

  if (phoneDigits.startsWith("0")) {
    const intlDigits = "41" + phoneDigits.substring(1);
    if (intlDigits.includes(queryDigits)) {
      return true;
    }
  }

  return false;
}

function splitFullName(fullName) {
  const cleaned = (fullName || "").trim();
  if (!cleaned.length) {
    return { first: "", last: "" };
  }

  const parts = cleaned.split(/\s+/);
  return {
    first: parts[0] || "",
    last: parts.slice(1).join(" ")
  };
}

function applyClientFields(clientData) {
  firstname.value = clientData.firstname || "";
  lastname.value = clientData.lastname || "";
  phone.value = clientData.phone || "";
}

function prefillClientData(clientId) {
  if (!clientId) {
    return;
  }

  const options = {
    "headers" :  authHeader()
  };

  axios
    .get(`${process.env.VUE_APP_API_URL}/Clients/getById?clientId=${clientId}`, options)
    .then(response => {
      applyClientFields(response.data || {});
    })
    .catch(() => {
      const fallback = selectedExistingClient.value || {};
      const split = splitFullName(fallback.name);
      applyClientFields({
        firstname: split.first,
        lastname: split.last,
        phone: fallback.phone || ""
      });
    });
}

function onExistingClientSelect(event) {
  const selected = event && event.value ? event.value : selectedExistingClient.value;
  if (selected && selected.clientid) {
    prefillClientData(selected.clientid);
  }
}

watch(selectedExistingClient, (value, previous) => {
  if (value && value.clientid) {
    prefillClientData(value.clientid);
    return;
  }

  if (previous && previous.clientid) {
    firstname.value = "";
    lastname.value = "";
    phone.value = "";
  }
});

function deleteBlocker()
{
     var options = {
        "headers" :  authHeader()
      };



            var json = JSON.stringify({});


      axios
      .post(`${process.env.VUE_APP_API_URL}/Appointments/deleteBlocker?blockerid=${blockerToDelete.value}`, json,  options)
      .then(response => {
          console.log(response.status)
          blocker.value = false;
          forceload.value = true;
          emptyForm();
          loadAppointments();
      })
      .catch(reason => {
          if(reason.message.includes("401"))
          {
            blocker.value = false;
            userService.logout();
            router.push({path: '/login'})

          }
          else
          {
            alert("erreur : " + reason.message);
          }
      });
}




function loadAppointments() {
  
  var view = fullcalendar.value.calendar.view
  
  if(currentView.value != view.title || forceload.value)
    {
      forceload.value = false;
      loading.value = true;
      events.value = [];

      currentView.value = view.title;

      var options = {
        "headers" :  authHeader()
      };

      var start = getDate(view.currentStart);
      var end = getDate(view.currentEnd);

        axios
            .get(`${process.env.VUE_APP_API_URL}/Appointments/GetAgenda?from=${start}&to=${end}`, options)
            .then(response => {
              events.value = response.data;
              if(props.appointmentEdit != null)
              {
                editedEventData.value = events.value.find(e => String(e.appid) === String(props.appointmentEdit)) || null;
                events.value = events.value.filter(e => String(e.appid) !== String(props.appointmentEdit));
              }
              console.log("events : " + events.value.length);
              loading.value = false;
      }).catch(reason => {
          if(reason.message.includes("401"))
          {
            userService.logout();
            router.push({path: '/login'})

          }
          else
          {
            alert("erreur : " + reason.message);
          }
      });
    }

}

function openAppointment(info)
{
  var id = info.event.id;
  if(id.length > 0)
  {
    store.$patch((state) => {
              state.currentClientFile = id;
  });


    router.push({path: '/clients'});
  } else if(info.event.backgroundColor != "lightgreen"){
    blockerToDelete.value = info.event.extendedProps.blockerid;
    blocker.value = true;

  }

  
}

function bookAppointment()        
{
  var minutes = -1;
  var formatteddate = "";
  timeerror.value = false;
  submitted.value = true;
   
  console.log(startTime.value);
  console.log(endTime.value);
  




  if(validateForm())
  {
     var options = {
        "headers" :  authHeader(true)
      };
    const basePayload = JSON.stringify({});


    if(props.appointmentEdit != null)
    {


        minutes = minDiff(startTime.value, endTime.value);
        if(minutes < 0)
        { 
          timeerror.value = true;
          return;
        }

         formatteddate = getDate(startTime.value) + getTime(startTime.value.toTimeString().substring(0,5));


      //we won't book a new one but edit the existing
         axios
      .post(`${process.env.VUE_APP_API_URL}/Appointments/update?appointmentTime=${formatteddate}&duration=${minutes}&appId=${props.appointmentEdit}`, basePayload, options)
      .then(response => {
          console.log(response.status)
          display.value = false;
          forceload.value = true;
          emit('close-modal');
      })
      .catch(reason => {
          if(reason.message.includes("401"))
          {
            userService.logout();
            router.push({path: '/login'})

          }
          else
          {
            alert("erreur : " + reason.message);
          }
      });


      return;
    }

    if(apptype.value == "appointment" && props.contextualClient == null)
    {
        const hasSelectedExistingClient = selectedExistingClient.value && selectedExistingClient.value.clientid;
        let clientData = {};
        if(hasSelectedExistingClient)
        {
          clientData = {
            services: [services.value]
          };
        }
        else
        {
          clientData =
          {
            firstname : firstname.value,
            lastname: lastname.value,
            phone: phone.value,
            length: "long",
            thickness: "épais",
            services: [services.value]
          };
        }
        var json = JSON.stringify(clientData);

        minutes = minDiff(startTime.value, endTime.value);
        if(minutes < 0)
        { 
          timeerror.value = true;
          return;
        }

         formatteddate = getDate(startTime.value) + getTime(startTime.value.toTimeString().substring(0,5));
        console.log(formatteddate);

   


        const appointmentUrl = hasSelectedExistingClient
          ? `${process.env.VUE_APP_API_URL}/Appointments?clientId=${selectedExistingClient.value.clientid}&appointmentTime=${formatteddate}&duration=${minutes}`
          : `${process.env.VUE_APP_API_URL}/Appointments?appointmentTime=${formatteddate}&duration=${minutes}`;

        axios
      .post(appointmentUrl, json, options)
      .then(response => {
          console.log(response.status)
          display.value = false;
          forceload.value = true;
          emptyForm();
          loadAppointments();
      })
      .catch(reason => {
          if(reason.message.includes("401"))
          {
            userService.logout();
            router.push({path: '/login'})

          }
          else
          {
            alert("erreur : " + reason.message);
          }
      });


    }
    else if(props.contextualClient != null)
    {
      console.log(props.contextualClient)
      // this is also an appointment, booked by clientID
       minutes = minDiff(startTime.value, endTime.value);
        if(minutes < 0)
        { 
          timeerror.value = true;
          return;
        }
        const clientData = 
        {
          services: [services.value]
        }
        const json = JSON.stringify(clientData);


         formatteddate = getDate(startTime.value) + getTime(startTime.value.toTimeString().substring(0,5));

            axios
      .post(`${process.env.VUE_APP_API_URL}/Appointments?clientId=${props.contextualClient}&appointmentTime=${formatteddate}&duration=${minutes}`, json, options)
      .then(response => {
          console.log(response.status)
          display.value = false;
          forceload.value = true;
          emit('close-modal');
      })
      .catch(reason => {
          if(reason.message.includes("401"))
          {
            userService.logout();
            router.push({path: '/login'})

          }
          else
          {
            alert("erreur : " + reason.message);
          }
      });



    }
    else if(apptype.value == "blocker")
    {
         minutes = minDiff(startTime.value, endTime.value);
        if(minutes < 0)
        { 
          timeerror.value = true;
          return;
        }

        formatteddate = getDate(startTime.value) + getTime(startTime.value.toTimeString().substring(0,5));
        console.log(formatteddate);


  

        axios
      .post(`${process.env.VUE_APP_API_URL}/Appointments/blocker?appointmentTime=${formatteddate}&duration=${minutes}&reason=${encodeURIComponent(blockerreason.value || "")}`, basePayload, options)
      .then(response => {
          console.log(response.status)
          display.value = false;
          forceload.value = true;
          emptyForm();
          loadAppointments();
      })
      .catch(reason => {
          if(reason.message.includes("401"))
          {
            userService.logout();
            router.push({path: '/login'})

          }
          else
          {
            alert("erreur : " + reason.message);
          }
      });
      display.value = false;
    }
    else if(apptype.value == "availability")
    {

    

  console.log("availability");

          var formattedstart = getDate(startTime.value) + getTime(startTime.value.toTimeString().substring(0,5));
          var formattedend = getDate(endTime.value) + getTime(endTime.value.toTimeString().substring(0,5));
      axios
      .post(`${process.env.VUE_APP_API_URL}/Plannings/single?start=${formattedstart}&end=${formattedend}`, basePayload, options)
      .then(response => {
          console.log(response.status)
          display.value = false;
          forceload.value = true;
          emptyForm();
          loadAppointments();
      })
     .catch(reason => {
          if(reason.message.includes("401"))
          {
            userService.logout();
            router.push({path: '/login'})

          }
          else
          {
            alert("erreur : " + reason.message);
          }
      });

      display.value = false;
    }
  }
}

function emptyForm()
{
  firstname.value = "";
  lastname.value = "";
  services.value = "";
  phone.value = "";
  blockerreason.value = "";
  selectedExistingClient.value = null;
  filteredClients.value = [];
}

function minDiff(d1, d2)
{
const diffMs = d2.getTime() - d1.getTime();
const diffMins = Math.floor((diffMs / 1000) / 60);
console.log(diffMins)
return diffMins
}

function selectSlots(info)
{
 //compute min time (00:00) and maxtime (23:59)
  minTime.value = new Date(info.start);
  minTime.value.setHours(0,0,0,0);

  maxTime.value = new Date(info.end);
  maxTime.value.setHours(23,59,59,0);


  startTime.value = info.start;
  endTime.value = info.end;

  display.value = true;
}

 
const options = ref({
        plugins: [ timeGridPlugin, dayGridPlugin, interactionPlugin ],
        initialView: loadView.value,
        initialDate: loadDate.value,
        firstDay: 1,
        events: events,
        hiddenDays : [0],
        views: {
          timeGridMobileWeek: {
            type: 'timeGrid',
            dateIncrement: { weeks: 1 },
            visibleRange(currentDate) {
              const base = new Date(currentDate);
              const day = base.getDay();
              const diffToMonday = (day + 6) % 7;
              const monday = new Date(base);
              monday.setDate(base.getDate() - diffToMonday);
              monday.setHours(0, 0, 0, 0);
              const sundayExclusive = new Date(monday);
              sundayExclusive.setDate(monday.getDate() + 6);
              return {
                start: monday,
                end: sundayExclusive
              };
            },
            buttonText: 'week'
          }
        },
        headerToolbar: {
          left: 'prev,next today',
          center: 'title',
          right: 'timeGridWeek,timeGridDay,dayGridMonth'
        }, 
        datesSet: loadAppointments,
        eventClick: openAppointment,
        slotMinTime: '08:00',
        slotMaxTime: '20:00',
        snapDuration : '00:15',
        slotDuration : '00:15',
        locale: 'fr-CH',
        allDaySlot: false,
        nowIndicator: true,
        selectable: true,
        select: selectSlots,
        longPressDelay: 700,
        selectOverlap: function(event) {
    return event.display === 'background';
  }
      });



</script>
